module.exports = __webpack_public_path__ + "img/ricelog_pinicon_093.201ad20c.png";